<div class="date-picker-filter-content">
  <form [formGroup]="datePickerFilterForm" [aria-label]="label">
    @if (isBetweenCondition) {
      <mat-form-field appearance="outline">
        <mat-label i18n="@@core.filter.from">From</mat-label>
        <input matInput [matDatepicker]="dp" formControlName="lowerDate" [aria-label]="labelFromValue" />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n="@@core.filter.until">Until</mat-label>
        <input matInput [matDatepicker]="dp2" formControlName="upperDate" [aria-label]="labelUntilValue" />
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>
    } @else {
      <mat-form-field appearance="outline">
        <mat-label i18n="@@core.filter.value">Value</mat-label>
        <input matInput [matDatepicker]="dp3" [aria-label]="label" />
        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </mat-form-field>
    }
  </form>
</div>
